import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const ChatbotWidget = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const el = document.getElementById("pepito-container");
    setContainer(el);
  }, []);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (
        event.data &&
        event.data.type === "chatbot-resize" &&
        event.data.height &&
        event.data.width
      ) {
        if (iframeRef.current) {
          iframeRef.current.style.height = event.data.height + "px";
          iframeRef.current.style.width = event.data.width + "px";
        }
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  if (!container) return null;

  return createPortal(
    <iframe
      ref={iframeRef}
      src="https://la-reyna-chatbot.vercel.app/chatbot"
      width="94"
      height="96"
      style={{ border: "none", position: "fixed", bottom: "0px", right: "0px", zIndex: 9999 }}
      allow="clipboard-write"
      title="pepito new"
    />,
    container
  );
};

export default ChatbotWidget;
